var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"speedbiz-ui-test"},[_c('sb-search-bar',{attrs:{"data":_vm.searchList},on:{"search":_vm.handleSearch,"reset":_vm.handleSearch}}),_c('sb-input-unit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }